export const specialNames = {
  PRODUCTION: "production",
  DEVELOPMENT: "development"
};
